// The one query-key factory (ADR 0023). Every hook takes its key from here, so
// invalidation after a mutation can name exactly what changed.
export const queryKeys = {
  me: () => ['me'] as const,
  tenant: () => ['tenant'] as const,
  navCounts: () => ['nav', 'counts'] as const,
  /** The optional roles switched on (GET /api/roles). */
  roles: () => ['roles'] as const,
  /** Everything under pay, for invalidation after an upload. */
  pay: () => ['pay'] as const,
  checks: (repId: string | undefined) => ['pay', 'checks', repId ?? 'me'] as const,
  teamReps: (view: string) => ['team', 'reps', view] as const,
  teamRep: (repId: string) => ['team', 'rep', repId] as const,
  lineItems: (params: Record<string, string | number | undefined>) =>
    ['pay', 'line-items', params] as const,
  customers: (repId: string | undefined, q: string) =>
    ['pay', 'customers', repId ?? 'me', q] as const,
  productTypes: (repId: string | undefined) => ['pay', 'product-types', repId ?? 'me'] as const,
  pending: (repId: string | undefined) => ['pay', 'pending', repId ?? 'me'] as const,
  check: (payDate: string, repId: string | undefined) =>
    ['pay', 'check', repId ?? 'me', payDate] as const,
  categories: (repId: string | undefined, scope: string, from?: string, to?: string) =>
    ['pay', 'categories', repId ?? 'me', scope, from ?? null, to ?? null] as const,
  /** Everything under admin users, for invalidation after a change. */
  adminUsers: () => ['admin', 'users'] as const,
  adminUserPage: (params: Record<string, string | number | undefined>) =>
    ['admin', 'users', 'page', params] as const,
  supervisors: () => ['admin', 'users', 'supervisors'] as const,
  /** The pay viewer's People list (ADR 0028). */
  peoplePage: (params: Record<string, string | number | undefined>) =>
    ['viewer', 'users', 'page', params] as const,
  externalIdTypes: () => ['admin', 'external-id-types'] as const,
  adminSettings: () => ['admin', 'settings'] as const,
  lineItemTable: () => ['admin', 'settings', 'line-item-table'] as const,
  adminNotices: () => ['admin', 'notices'] as const,
  /** Everything about product types, for invalidation after a change. */
  products: () => ['admin', 'products'] as const,
  product: (id: string) => ['admin', 'products', 'one', id] as const,
  productSourceColumns: (id: string) => ['admin', 'products', 'source-columns', id] as const,
  productPreview: (id: string) => ['admin', 'products', 'preview', id] as const,
  /** Everything about uploads and the pay dates they make up, for invalidation. */
  adminUploads: () => ['admin', 'uploads'] as const,
  adminUploadPage: (params: Record<string, string | number | undefined>) =>
    ['admin', 'uploads', 'page', params] as const,
  adminUpload: (id: string) => ['admin', 'uploads', 'one', id] as const,
  deletionPreview: (id: string) => ['admin', 'uploads', 'deletion-preview', id] as const,
  pendingSummary: () => ['admin', 'uploads', 'pending-summary'] as const,
  payDatePage: (params: Record<string, string | number | undefined>) =>
    ['admin', 'uploads', 'pay-dates', params] as const,
  myNotices: () => ['notices'] as const,
  /** The operator dashboard (ADR 0016's A25 amendment). */
  operatorDashboard: () => ['operator', 'dashboard'] as const,
};
